<script setup lang="ts">
const title = 'Pinturas Acoxpa - Granados Pinturas Industriales'
const description = 'Proveedor especializado en pinturas industriales en México. Soluciones profesionales para flotillas, construcción e industria. Solicite su cotización.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  twitterCard: 'summary_large_image'
})

useHead({
  htmlAttrs: {
    lang: 'es-MX'
  },
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ]
})
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
